.prose {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface);
}

.prose > * + * {
  margin-block-start: 1em;
}

.prose h1 {
  font: var(--type-headline-lg);
  letter-spacing: var(--tracking-headline-lg);
}

.prose h2 {
  font: var(--type-headline-md);
  letter-spacing: var(--tracking-headline-md);
}

.prose h3 {
  font: var(--type-headline-sm);
  letter-spacing: var(--tracking-headline-sm);
}

.prose h4 {
  font: var(--type-title-lg);
  letter-spacing: var(--tracking-title-lg);
}

.prose h5,
.prose h6 {
  font: var(--type-title-md);
  letter-spacing: var(--tracking-title-md);
}

.prose h1,
.prose h2,
.prose h3,
.prose h4,
.prose h5,
.prose h6 {
  margin-block-start: 1.5em;
  margin-block-end: 0.5em;
}

.prose p {
  margin-block: 0.75em;
}

.prose a {
  color: var(--md-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

@media (hover: hover) {
  .prose a:hover {
    color: var(--md-primary);
  }
}

.prose strong {
  font-weight: 600;
}

.prose ul,
.prose ol {
  padding-inline-start: 1.5em;
  margin-block: 0.75em;
}

.prose li + li {
  margin-block-start: 0.375em;
}

.prose blockquote {
  border-inline-start: 3px solid var(--md-outline-variant);
  padding-inline-start: 1em;
  color: var(--md-on-surface-variant);
  font-style: italic;
  margin-inline: 0;
}

.prose code {
  font-family: var(--font-mono);
  font-size: 0.9em;
  background: var(--md-surface-container-low);
  padding: 0.125em 0.375em;
  border-radius: var(--shape-xs);
}

.prose pre {
  background: var(--md-surface-container-low);
  padding: 1em;
  border-radius: var(--shape-sm);
  overflow-x: auto;
}

.prose pre code {
  background: none;
  padding: 0;
}

.prose table {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  width: 100%;
  border-collapse: collapse;
}

.prose th,
.prose td {
  border-block-end: 1px solid var(--md-outline-variant);
  padding: 0.5em 0.75em;
  text-align: start;
}

.prose th {
  font-weight: 600;
  color: var(--md-on-surface-variant);
}

.prose img {
  border-radius: var(--shape-sm);
}

.prose hr {
  border: none;
  border-block-start: 1px solid var(--md-outline-variant);
  margin-block: 1.5em;
}
